import { FallingLines } from "react-loader-spinner";

const PagesLoading = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <FallingLines
        color="rgba(41, 128, 185, 1)"
        width="100"
        visible={true}
        ariaLabel="falling-circles-loading"
      />
    </div>
  );
};

export default PagesLoading;
